import React from "react";
import { useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Chip from "@mui/material/Chip";
import SearchField from "react-search-field";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Initialize from "./Initailize";

import Startmessage from "./Startmessage";
import Stopmessage from "./Stopmessage";
import Terminated from "./Terminated";
import FailedConUpdatemessage from "../FailedConUpdatemessage";
import FailedMessage from "../FailedMessage";
import FailedStopmessage from "../FailedStopmessage";
import FailedStartmessage from "../FailedStartmessage";
import Retryingmessage from "../Retryingmessage";
import Failedaddconcreate from "../Failedaddconcreate";
import FailedAddmessage from "../FailedAddmessage";
import FailedConCreatemessage from "../FailedConCreatemessage";
import FailedCreatemessage from "../FailedCreatemessage";
import FailedDeletemessage from "../FailedDeletemessage";
import Failedremovemessage from "../Failedremovemessage";
import FailedAddConUpdatemessage from "../FailedAddConUpdatemessage"
import FailedCordonmessage from "../FailedCordonmessage"

const options = [
  { id: 1, name: "Lab Name", value: "lab_name" },
  // { id: 3, name: "Status", value: "status" },
];

const LabList = ({ ...rest }) => {
  const [instancelist, setinstancelist] = useState([]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetch(`${process.env.REACT_APP_API_URL}/api/manageCloudlabs/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.detail) {
          } else {
            setinstancelist(data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, instancelist.length - page * rowsPerPage);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const [searchitems, setSearchItems] = React.useState(0);

  return (
    <>
      {/* <ButtonGroup
        sx={{ mr: 2 }}
        variant="outlined"
        style={{
          backgroundColor: "#ffff",
          color: "rgb(90, 90, 90)",
          border: "1px solid rgb(221, 221, 221)",
        }}
        aria-label="split button"
      >
        <Button
          style={{
            width: "150px",
            backgroundColor: "#ffff",
            color: "rgb(90, 90, 90)",
            border: "1px solid rgb(221, 221, 221)",
          }}
        >
          {options[selectedIndex].name} {" = "}
        </Button>
        <Button
          style={{
            backgroundColor: "#ffff",
            color: "rgb(90, 90, 90)",
            border: "1px solid rgb(221, 221, 221)",
          }}
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleClick}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper>
          <MenuList id="split-button-menu">
            {options.map((option, index) => (
              <MenuItem
                key={option.name}
                selected={index === selectedIndex}
                onClick={(event) => handleMenuItemClick(event, index)}
              >
                {option.name}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </Popover>
      <SearchField
        value={searchitems}
        placeholder="Search..."
        onChange={(event) => {
          setSearchItems(event);
        }}
        classNames="test-class"
      /> */}
      <Box style={{ marginTop: "-30px"}} >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            sx={{ flex: "1 1 100%" }}
            style={{
              fontSize: "x-large",
              lineHeight: "2.5",
              paddingLeft: "24px",
            }}
            color="textPrimary"
            variant="body1"
          >
            Cloud
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "-20px", marginBottom: "10px", paddingX: "10px", '@media (max-width: 768px)': { flexDirection: 'column', marginTop: 0 } }}>
          <SearchField
            value={searchitems}
            placeholder="Search by Lab Name"
            onChange={(event) => {
              setSearchItems(event);
            }}
            classNames="test-class"
          />
        </Box>
      </Box>
      <Box sx={{ pt: 1 }}>
        <Card {...rest}>
          <PerfectScrollbar>
            <Box sx={{ minWidth: 1000 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" width="10%">
                        Lab Name
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Provider
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Status
                      </TableCell>
                      <TableCell align="center" width="10%">
                        No of Trainee
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Lab ID
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Budget Credits
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {instancelist.length > 0 ? (
                    <TableBody>
                      {instancelist
                        .filter((val) => {
                          if (searchitems == "") {
                            return val;
                          } else if (
                            val[options[selectedIndex].value]
                              .toLowerCase()
                              .includes(searchitems.toLowerCase())
                          ) {
                            return val;
                          }
                        })
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((instance) => (
                          <TableRow hover key={instance.id}>
                            <TableCell align="center" width="10%">
                              {instance.lab_name}
                            </TableCell>
                            <TableCell align="center" width="10%">
                              {instance.provider}
                            </TableCell>
                            <TableCell align="center" width="10%">
                              {instance.status === "Provisioning" ? (
                                <Chip
                                  color="primary"
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Scheduled" ? (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(44 189 186)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Active" ? (
                                <Chip
                                  color="primary"
                                  style={{ backgroundColor: "rgb(44 189 186)" }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Stopped" ? (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(228 193 3 / 94%)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : instance.status === "Cordoned" ? (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(98 95 80 / 94%)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              ) : (
                                <Chip
                                  color="primary"
                                  style={{
                                    backgroundColor: "rgb(228 3 3 / 94%)",
                                  }}
                                  label={instance.status}
                                  size="small"
                                />
                              )}
                            </TableCell>
                            <TableCell align="center" width="10%">
                              {instance.number_of_trainee}
                            </TableCell>
                            <TableCell align="center" width="10%">
                              {instance.id}
                            </TableCell>
                            <TableCell align="center" width="10%">
                              <Typography
                                variant="contained"
                                color="Primary"
                                align="center"
                              >
                                {`${instance.credit}`}
                              </Typography>
                            </TableCell>
                            <TableCell align="center" width="10%">
                              {1 === 1 ? (
                                <Button size="sm">
                                  <Link
                                    to={{
                                      pathname: "/app/cloudlab/moreinfo",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "InstanceID",
                                        instance.id
                                      );
                                    }}
                                    style={{ color: "#FFF" }}
                                  >
                                    <ArrowRightAltIcon color="primary" />
                                  </Link>
                                </Button>
                              // ) : instance.status === "Creating" || instance.status === "Provisioning" || instance.status === "Scheduled" ? (
                              //   <Initialize />
                              // ) : instance.status === "Stopping" || instance.status === "stopping" || instance.status === "stop initiated" || instance.status === "Stop Initiated" ? (
                              //   <Stopmessage />
                              // ) : instance.status === "Starting" || instance.status === "starting" || instance.status === "start initiated" || instance.status === "Start Initiated" ? (
                              //     <Startmessage />
                              // ) : instance.status === "failed_con_update" ? (
                              //   <FailedConUpdatemessage />
                              // ) : instance.status === "Failed" ? (
                              //   <FailedMessage />
                              // ) : instance.status === "failed_stop" ? (
                              //   <FailedStopmessage />
                              // ) : instance.status === "failed_start" ? (
                              //   <FailedStartmessage />
                              // ) : instance.status === "failed_start" ? (
                              //   <FailedStartmessage />
                              // ) : instance.status === "Retrying" ? (
                              //   <Retryingmessage />
                              // ) : instance.status === "failed_add_con_create" ? (
                              //   <Failedaddconcreate />
                              // ) : instance.status === "failed_add" ? (
                              //   <FailedAddmessage />
                              // ) : instance.status === "failed_con_create" ? (
                              //   <FailedConCreatemessage />
                              // ) : instance.status === "failed_add_con_update" ? (
                              //   <FailedAddConUpdatemessage />
                              // ) : instance.status === "failed_create" ? (
                              //   <FailedCreatemessage />
                              // ) : instance.status === "failed_delete" ? (
                              //   <FailedDeletemessage />
                              // ) : instance.status === "failed_remove" ? (
                              //   <Failedremovemessage />
                              // ) : instance.status === "failed_cordon" ? (
                              //   <FailedCordonmessage />
                              ) : (
                                <Terminated />
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  ) : (
                    <TableBody align="center">
                      <TableCell>No Data Available</TableCell>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {instancelist.length > 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '20px' }}>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={instancelist.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Divider />
          </PerfectScrollbar>
        </Card>
      </Box>
    </>
  );
};

export default LabList;
